/**
 * @typedef {'s' | 'm' | 'l' | 'xl'} ModalSize
 */

/**
 * @typedef {16 | 20 | 24 | 32 | 40 | 48} NumberSize
 */

/**
 * @type {{X_SMALL: Size, SMALL: Size, MEDIUM: Size, LARGE: Size, X_LARGE: Size}}
 */
export const SIZE = {
  LARGE: 'l',
  MEDIUM: 'm',
  SMALL: 's',
  X_LARGE: 'xl',
}

export const SIZES = new Set(Object.values(SIZE))

export const NUMBER_SIZE = {
  size16: 16,
  size20: 20,
  size24: 24,
  size32: 32,
  size40: 40,
  size44: 44,
  size48: 48,
}

export const NUMBER_SIZES = new Set(Object.values(NUMBER_SIZE))
